import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 305  -  转场开始
 */

export default class EventConvertSceneStart extends EventBase {
  /**
   * 构造函数
   */
  public constructor() {
    super()
    this.Parameter = ['']
  }

  // #region 事件内关键属性参数
  /**
   * 转场图片名称
   */ get PicName() {
    return this.Parameter?.[0] ?? ''
  }
  set PicName(value) {
    this.Parameter![0] = value.toString()
  }
  // #endregion

  /**
   * 事件ID
   */
  Code = EventID.ConvertSceneStart

  /**
   * 获得该事件在事件列表的描述信息
   */
}
